module.exports = __webpack_public_path__ + "static/media/rub-out-the-word.ca2db95c.txt";